<p-popover #taskBankFilterPanel>
  <div style="min-width: 240px;">

    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
      <span class="fw-semibold">Filter</span>
      <span *ngIf="selectedServiceCode || selectedEvent" class="fw-semibold anchor pointer-cursor" (click)="clearAll()">Clear All</span>
    </div>

    <div class="py-3 border-bottom" *ngIf="hasServiceCodeFilter">
      <h6>ASC (Additional Service Code)</h6>
      <div class="d-flex flex-column">
        <div *ngFor="let serviceCode of serviceCodeFilter" class="mb-1">
          <p-radioButton [inputId]="serviceCode.key" name="serviceCode" [value]="serviceCode.key"
            [(ngModel)]="selectedServiceCode" (ngModelChange)="onServiceCodeChange($event)" /> &nbsp;
          <label [for]="serviceCode.key" class="ml-2">
            {{ serviceCode.name }}
          </label>
        </div>
      </div>
    </div>

    <div class="py-3" *ngIf="hasEventsFilter">
      <h6>Events</h6>
      <div class="d-flex flex-column">
        <div *ngFor="let event of eventsFilter" class="mb-1">
          <p-radioButton [inputId]="event.key" name="event" [value]="event.key" [(ngModel)]="selectedEvent"
            (ngModelChange)="onEventChange($event)" /> &nbsp;
          <label [for]="event.key" class="ml-2">
            {{ event.name }}
          </label>
        </div>
      </div>
    </div>

    <div class="py-3 text-center" *ngIf="!hasAnyFilterOptions">
      No filters available for this tab.
    </div>

  </div>
</p-popover>